import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=a24b19d4&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=ts"
export * from "./MaintenancePage.vue?vue&type=script&lang=ts"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=a24b19d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24b19d4",
  null
  
)

export default component.exports